// import ChessRestClient from '@/Api/ChessRestClient';
// import {useQuery} from '@tanstack/react-query';

// interface GetMessagesParams {
//   channel_id: number; // required path param
//   limit?: number; // default 10, max 20
//   before_id?: number; // get older messages
//   after_id?: number; // get newer messages
//   mark_read?: boolean | 1 | 'true' | 'yes'; // optional flag
// }

// export default function useGetMessagesApi(
//   params: GetMessagesParams,
//   handleOnSuccess?: (data: any) => void,
//   handleOnError?: (error: any) => void,
// ) {
//   const {channel_id, limit = 10, before_id, after_id, mark_read} = params;

//   const query = useQuery({
//     queryKey: ['messages', channel_id, {limit, before_id, after_id, mark_read}],
//     queryFn: async () => {
//       const queryParams = new URLSearchParams();

//       if (limit) queryParams.append('limit', limit.toString());
//       if (before_id) queryParams.append('before_id', before_id.toString());
//       if (after_id) queryParams.append('after_id', after_id.toString());
//       if (mark_read) queryParams.append('mark_read', String(mark_read));

//       const url = `https://f186fba8-1d4f-4017-b2b3-c78973e5b914.mock.pstmn.io/inbox/get_messages/${channel_id}?${queryParams.toString()}`;

//       // Example: const url = `/inbox/get_messages/${channel_id}?${queryParams.toString()}`; // when using real API

//       const response = await ChessRestClient.get(url);
//       return response.data;
//     },
//     enabled: !!channel_id, // only run if we have a valid channel_id
//     onSuccess: data => handleOnSuccess?.(data),
//     onError: error => handleOnError?.(error),
//   });

//   return {
//     ...query, // gives access to data, isLoading, isError, refetch, etc.
//   };
// }

import ChessRestClient from '@/Api/ChessRestClient';
import {useQuery, useQueryClient} from '@tanstack/react-query';

export default function useGetMessagesApi(
  channel_id: number,
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: any) => void,
) {
  const query = useQuery({
    queryKey: ['messages', channel_id],
    queryFn: async () => {
      if (!channel_id) throw new Error('channel_id is required');

      // for now you only pass channel_id
      const url = `/inbox/get_messages/${channel_id}`;

      // Example (real endpoint):
      // const url = `/inbox/get_messages/${channel_id}`;

      const response = await ChessRestClient.get(url);
      return response?.data ?? [];
    },
    
    enabled: !!channel_id, // only run if channel_id is valid
    onSuccess: data => handleOnSuccess?.(data),
    onError: error => handleOnError?.(error),
    structuralSharing: false, 
  });

  const qc = useQueryClient()
  const refetchForChannel = (id: number) =>
    qc.refetchQueries({ queryKey: ['messages', id], exact: true })

  return {
    ...query, // gives you data, isLoading, isError, refetch, etc.
    refetchForChannel
  };
}
